import { Box } from '@chakra-ui/react';

import { LoaderIcon } from 'Asset/icon';

import styles from './styles.module.css';

const ListLoader = () => (
  <Box className={styles['list-loader__container']} data-testid="list-loader">
    <LoaderIcon className={styles['list-loader__spinner']} size="40px" color="var(--color-primary60)" />
  </Box>
);

export default ListLoader;
